import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/auth/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError("Passwords don't match");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: form.password });
      setUser(false);
      toast.success("Password updated. Please log in with your new password.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Choose a new password" subtitle="At least 8 characters, including a letter and a number.">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
        {[["password", "New password"], ["confirm", "Confirm new password"]].map(([k, l]) => (
          <div key={k} className="space-y-2">
            <Label htmlFor={`reset-${k}`}>{l}</Label>
            <Input id={`reset-${k}`} type="password" required minLength={8} value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="field" data-testid={`reset-${k}-input`} />
          </div>
        ))}
        {error && <p className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="reset-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit-button">{busy ? "Saving..." : "Update password"}</button>
        <p className="text-center text-sm text-slate-400"><Link to="/forgot-password" className="text-emerald-400 hover:underline">Request a new link</Link></p>
      </form>
    </AuthShell>
  );
}
